import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivateGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.userIsLoggedIn()) {
      localStorage.setItem(
        'APPTenfieldPlayerRedirectAfterLogin',
        JSON.stringify({route: route.routeConfig.path, params: route.queryParams})
      );
      this.router.navigate(['/ingreso']);
      return false;
    }

    return true;
  }
}
